import { useEffect, useState } from "react";
import { Menu, X, Zap } from "lucide-react";

const NAV = [
  { id: "problema", label: "Problema" },
  { id: "comparativa", label: "Comparativa" },
  { id: "sistema", label: "Sistema" },
  { id: "resultados", label: "Resultados" },
  { id: "calculadora", label: "Calculadora" },
  { id: "para-quien-es", label: "Para quién es" },
  { id: "contacto", label: "Contacto" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-black/70 backdrop-blur-xl border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-3 flex items-center justify-between">
        <a href="#top" data-testid="header-logo" className="flex items-center group">
          <img
            src="https://customer-assets.emergentagent.com/job_automotive-boost-3/artifacts/8ujqnsw0_LOGO-FUELKERS.png"
            alt="Fuelkers"
            className="h-20 sm:h-24 lg:h-28 w-auto object-contain transition-transform duration-300 group-hover:scale-105"
            style={{filter:'brightness(0) invert(1) drop-shadow(0 0 22px rgba(255,255,255,0.25))'}}
          />
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <a
              key={n.id}
              href={`#${n.id}`}
              data-testid={`nav-link-${n.id}`}
              className="text-sm text-white/70 hover:text-white transition-colors relative group"
            >
              {n.label}
              <span className="absolute -bottom-1 left-0 w-0 h-px bg-[#00A0A0] group-hover:w-full transition-all duration-300" />
            </a>
          ))}
        </nav>

        <a
          href="#contacto"
          data-testid="header-cta"
          className="hidden md:inline-flex btn-angular items-center gap-2 px-6 py-2.5 bg-[#FFD700] hover:bg-[#FFE34D] text-black text-xs font-stencil tracking-widest uppercase transition-all duration-300"
          style={{boxShadow:'4px 4px 0 #00A0A0'}}
        >
          RESERVAR LLAMADA
        </a>

        <button
          data-testid="mobile-menu-toggle"
          aria-label="Menu"
          className="lg:hidden text-white p-2"
          onClick={() => setOpen((o) => !o)}
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-black/95 backdrop-blur-xl border-t border-white/10">
          <div className="px-4 py-6 flex flex-col gap-4">
            {NAV.map((n) => (
              <a
                key={n.id}
                href={`#${n.id}`}
                onClick={() => setOpen(false)}
                className="text-white/80 hover:text-white text-base"
              >
                {n.label}
              </a>
            ))}
            <a
              href="#contacto"
              onClick={() => setOpen(false)}
              className="mt-2 px-5 py-3 bg-[#FFD700] text-black text-center text-sm font-stencil tracking-widest uppercase"
            >
              RESERVAR LLAMADA
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
